import { cva, type VariantProps } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/utils';

// MUI CircularProgress の代替コンポーネント
const spinnerVariants = cva('animate-spin text-blue-600', {
  variants: {
    size: {
      sm: 'h-4 w-4',
      default: 'h-6 w-6',
      lg: 'h-10 w-10',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export interface SpinnerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof spinnerVariants> {}

function Spinner({ className, size, ...props }: SpinnerProps) {
  return (
    <div role="status" aria-label="読み込み中" className={cn('inline-flex', className)} {...props}>
      <Loader2 className={spinnerVariants({ size })} />
      <span className="sr-only">読み込み中</span>
    </div>
  );
}

export { Spinner, spinnerVariants };
